"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PlaybackPause = function PlaybackPause(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M9.816 17.631H7.94a.937.937 0 01-.938-.937V7.319c0-.518.42-.938.938-.938h1.875c.517 0 .937.42.937.938v9.375c0 .518-.42.938-.937.938zm4.375 0a.937.937 0 01-.938-.937V7.319c0-.518.42-.938.938-.938h1.875c.517 0 .937.42.937.938v9.375c0 .518-.42.938-.937.938H14.19z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(PlaybackPause);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PlaybackPause, "PlaybackPause", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/PlaybackPause.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/PlaybackPause.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9QbGF5YmFja1BhdXNlLnRzeCJdLCJuYW1lcyI6WyJQbGF5YmFja1BhdXNlIiwicHJvcHMiLCJyZWYiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7OztBQUVBLElBQU1BLGFBQTZFLEdBQUcsU0FBaEZBLGFBQWdGLENBQUNDLEtBQUQsRUFBUUMsR0FBUjtBQUFBLFNBQ3BGO0FBQUssSUFBQSxLQUFLLEVBQUUsRUFBWjtBQUFnQixJQUFBLE1BQU0sRUFBRSxFQUF4QjtBQUE0QixJQUFBLE9BQU8sRUFBQztBQUFwQyxLQUFvREQsS0FBcEQ7QUFBMkQsSUFBQSxHQUFHLEVBQUVDO0FBQWhFLE1BQ0U7QUFDRSxJQUFBLENBQUMsRUFBQyxzUUFESjtBQUVFLElBQUEsSUFBSSxFQUFDO0FBRlAsSUFERixDQURvRjtBQUFBLENBQXRGOztlQVNlLHVCQUFXRixhQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLGEiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IFBsYXliYWNrUGF1c2U6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8U1ZHU1ZHRWxlbWVudCwgU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+ID0gKHByb3BzLCByZWYpID0+IChcbiAgPHN2ZyB3aWR0aD17MjR9IGhlaWdodD17MjR9IHZpZXdCb3g9XCIwIDAgMjQgMjRcIiB7Li4ucHJvcHN9IHJlZj17cmVmfT5cbiAgICA8cGF0aFxuICAgICAgZD1cIk05LjgxNiAxNy42MzFINy45NGEuOTM3LjkzNyAwIDAxLS45MzgtLjkzN1Y3LjMxOWMwLS41MTguNDItLjkzOC45MzgtLjkzOGgxLjg3NWMuNTE3IDAgLjkzNy40Mi45MzcuOTM4djkuMzc1YzAgLjUxOC0uNDIuOTM4LS45MzcuOTM4em00LjM3NSAwYS45MzcuOTM3IDAgMDEtLjkzOC0uOTM3VjcuMzE5YzAtLjUxOC40Mi0uOTM4LjkzOC0uOTM4aDEuODc1Yy41MTcgMCAuOTM3LjQyLjkzNy45Mzh2OS4zNzVjMCAuNTE4LS40Mi45MzgtLjkzNy45MzhIMTQuMTl6XCJcbiAgICAgIGZpbGw9XCJjdXJyZW50Q29sb3JcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihQbGF5YmFja1BhdXNlKTtcbiJdfQ==